module.exports = __webpack_public_path__ + "img/qrcode@teacher.19be6a6c.png";